import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

export interface IFilterProps {
  queryString: string;
  title: string;
  icon?: JSX.Element;
  trackClickQuickFilter(): void;
}

export const Filter: React.FC<IFilterProps> = ({ queryString, title, icon, trackClickQuickFilter }) => {
  return (
    <LinkButton
      href={queryString}
      size="M"
      theme="fill_white_primary"
      beforeIcon={icon}
      onClick={trackClickQuickFilter}
    >
      {title}
    </LinkButton>
  );
};
